import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Order} from "../../../model/order";
import {OrderService} from "../../../service/order.service";
import * as $ from 'jquery';
import {PerformanceService} from "../../../service/performance.service";
import {LoginIdService} from "../../../service/login-id.service";
import {CountryService} from "../../../service/country.service";
import {PlatformProfile} from "../../../model/platformprofile";
import {forkJoin, Subscription} from "rxjs";
import {startWith} from "rxjs/operators";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  platformProfile: PlatformProfile;
  mobile: boolean = false;

  showCoInformationModal: boolean = false;
  showSavedTimeInformationModal: boolean = false;

  orders: Order[] = [];

  sliderInterval;
  sliderIndex;
  totalNumberOfSlides = 3;

  numberOfDocuments: number = 0;
  numberOfSpecialDocuments: number = 0;
  numberOfBauaktenDocuments: number = 0;
  loadingPerformance: boolean = true;
  loginIdServiceSubscription: Subscription;

  constructor(private orderService: OrderService, private router: Router,
              private performanceService: PerformanceService, private loginIdService: LoginIdService) {
  }

  async ngOnInit(): Promise<any> {
    this.loginIdService.loginServiceInitialized$.toPromise().then(() => {
      this.sliderIndex = 0;
      this.sliderInterval = setInterval(() => {
        this.slide();
      }, 10000);

      if (window.screen.width <= 1000) { // 768px portrait
        this.mobile = true;
      }

      this.loginIdServiceSubscription = this.loginIdService.loginIdChanged$.pipe(startWith(true)).subscribe(() => {
        const documentCountObservable = this.performanceService.getDocumentCount();
        const specialDocumentCountObservable = this.performanceService.getSpecialDocumentCount();
        const bauaktenDocumentCountObservable = this.performanceService.getBauaktenDocumentCount();
        forkJoin({
          documentCount: documentCountObservable,
          specialDocumentCount: specialDocumentCountObservable,
          bauaktenDocumentCount: bauaktenDocumentCountObservable
        }).subscribe({
          next: (results) => {
            this.numberOfDocuments = results.documentCount;
            this.numberOfSpecialDocuments = results.specialDocumentCount;
            this.numberOfBauaktenDocuments = results.bauaktenDocumentCount;
            this.loadingPerformance = false;
          }
        })

        this.platformProfile = JSON.parse(sessionStorage.getItem("platform"));

      });
    });
  }

  slide() {
    this.sliderIndex++;
    if (this.sliderIndex > this.totalNumberOfSlides - 1) {
      this.sliderIndex = 0;
    }
    $('#r' + this.sliderIndex).trigger('click');

    clearInterval(this.sliderInterval)
    this.sliderInterval = setInterval(() => {
      this.slide()
    }, 10000)
  }

  switchSlide(index) {
    this.sliderIndex = index
    clearInterval(this.sliderInterval);
    this.sliderInterval = setInterval(() => {
      this.slide()
    }, 10000)
  }

  arrowSlide(index) {
    this.sliderIndex = index;
    if (this.sliderIndex === -2) {
      this.sliderIndex = this.totalNumberOfSlides - 2
    }
    this.slide()
    clearInterval(this.sliderInterval);
    this.sliderInterval = setInterval(() => {
      this.slide()
    }, 10000)
  }

  ngOnDestroy() {

    if (this.loginIdServiceSubscription) {
      this.loginIdServiceSubscription.unsubscribe();
    }
    clearInterval(this.sliderInterval)
  }

  displayCoInformationModal() {
    this.showCoInformationModal = true;
  }

  displaySavedTimeInformationModal() {
    this.showSavedTimeInformationModal = true;
  }

  public calculateCOPerformance(numberOfDocuments: number, numberOfBauaktenDocuments: number, factor: number): number {
    return (numberOfDocuments - numberOfBauaktenDocuments) * factor + numberOfBauaktenDocuments * 5;
  }

  public calculateSavedTimePerformance(numberOfDocuments: number, numberOfSpecialDocuments: number): number {
    let numberOfNormalDocuments = numberOfDocuments - numberOfSpecialDocuments;
    return numberOfNormalDocuments * 2.7 + numberOfSpecialDocuments * 5.0;
  }

  public calculateCostPerformance(numberOfDocuments: number, numberOfSpecialDocuments: number, numberOfBauaktenDocuments: number): number {
    let numberOfNormalDocuments = numberOfDocuments - numberOfSpecialDocuments - numberOfBauaktenDocuments;
    let normalCosts = 31.17 * numberOfNormalDocuments * 2.7 + 31.17 * numberOfSpecialDocuments * 5.0;
    let docestateCosts = numberOfNormalDocuments * 30.0 + numberOfSpecialDocuments * 60.0
    return normalCosts - docestateCosts + numberOfBauaktenDocuments * 300;
  }

  public isAdmin(): boolean {
    return this.loginIdService.isAdmin();
  }


}
